export const PULSELEADS_AUTO_LEAD_REASSIGNMENT_TITLE = 'title.pulseleads.autoLeadReassignment';
export const PULSELEADS_AUTO_LEAD_REASSIGNMENT_STATUS_RULE_TITLE = 'title.pulseleads.autoLeadReassignment.statusRule';
export const PULSELEADS_AUTO_LEAD_REASSIGNMENT_TERMINATED_AGENT_RULE_TITLE = 'title.pulseleads.autoLeadReassignment.terminatedAgentRule';

export const PULSELEADS_AUTO_LEAD_REASSIGNMENT_STATUS_RULE_NAMESPACE = 'PULSELEADS-AUTO-LEAD-REASSIGNMENT-STATUS-RULE';
export const PULSELEADS_AUTO_LEAD_REASSIGNMENT_TERMINATED_AGENT_RULE_NAMESPACE = 'PULSELEADS-AUTO-LEAD-REASSIGNMENT-TERMINATED-AGENT-RULE';

export const PULSELEADS_AUTO_LEAD_REASSIGNMENT_PATH = '/auto-lead-reassignment';
export const PULSELEADS_AUTO_LEAD_REASSIGNMENT_STATUS_RULE_PATH = '/status-rule';
export const PULSELEADS_AUTO_LEAD_REASSIGNMENT_TERMINATED_AGENT_RULE_PATH = '/terminated-agent-rule';
